<template>
  <div>
    <el-form label-position="top" size="small">
      <el-row :gutter="10">
        <el-col :span="6">
          <!--  运单号   -->
          <el-form-item :label="$t('GlobalSetObj.waybillNumber')">
            <el-input
              v-model="queryForm.params.waybillNumber"
              :placeholder="$t('collectionCenter.pleaseInput')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!--  解除时间   -->
          <el-form-item :label="$t('navbar.jiechuTime')">
            <el-date-picker
              v-model="queryForm.params.releaseTime"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('GlobalSetObj.endDate')"
              :start-placeholder="$t('GlobalSetObj.startDate')"
              range-separator="-"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--  解除类型   -->
          <el-form-item :label="$t('navbar.ReleaseType')">
            <el-select
              v-model="queryForm.params.unRestrictTypeList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              multiple
              style="width: 100%"
            >
              <!--登记问题件距离-->
              <el-option :label="$t('navbar.RegisterProblemDistance')" :value="1" />
              <!--强制提供照片-->
              <el-option :label="$t('navbar.ForcePhoto')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!--  操作   -->
          <el-form-item>
            <!--搜索-->
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm()"
            >{{ $t('newOrder.reset') }}
            </el-button>
            <!--新增-->
            <el-button
              icon="el-icon-plus" size="small" type="primary"
              @click="addDeregistration"
            >{{ $t('GlobalSetObj.add') }}
            </el-button>
            <!--导出-->
            <el-button
              icon="el-icon-download" size="small" type="primary"
              @click="exportExcel"
            >{{ $t('newOrder.export') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table
      :key="tableKey"
      ref="restrictionTable"
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="70"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :align="item.cloAlign"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="item.isTips"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'statusName'">
            <el-tag v-if="scope.row.status === 1">{{ scope.row.statusName }}</el-tag>
            <el-tag v-else type="danger">{{ scope.row.statusName }}</el-tag>
          </div>
          <div v-else-if="item.prop === 'mustDistanceName'">
            <el-tag v-if="scope.row.mustPic === 1">{{ $t('GlobalSetObj.yes') }}</el-tag>
            <el-tag v-else type="danger">{{ $t('GlobalSetObj.No') }}</el-tag>
          </div>
          <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '- -' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('collectionCenter.operation')"
        align="center"
        fixed="right"
        width="80"
      >
        <template slot-scope="scope">
          <el-button
            icon="el-icon-delete"
            size="mini"
            style="color: #f56c6c; font-size: 22px"
            type="text"
            @click="deleteDeregistration(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 新增解除限制 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('navbar.xinzengzhanghaoxianzhi')"
      :visible.sync="addDialog"
      top="5vh"
      width="500px"
    >
      <el-form
        ref="restrictionLiftedRef"
        :model="restrictionLiftedForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <!--解除的运单号-->
            <el-form-item
              :label="$t('navbar.jiechuWillybNumber')"
              :rules="[
                { required: true, message: $t('collectionCenter.notNull'), trigger: 'blur' }
              ]"
              prop="waybillNumbers"
            >
              <el-input
                v-model="restrictionLiftedForm.waybillNumbers"
                :placeholder="$t('navbar.pasteWaybillNumber')"
                rows="8"
                style="width: 100%"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--  解除限制类型   -->
            <el-form-item
              :label="$t('navbar.rescissionTypeName')"
              :rules="[
                {
                  required: true,
                  message: $t('collectionCenter.notNull'),
                  trigger: ['blur', 'change']
                }
              ]"
              prop="unRestrictTypeList"
            >
              <el-checkbox-group v-model="restrictionLiftedForm.unRestrictTypeList">
                <el-checkbox :label="1">{{ $t('navbar.RegisterProblemDistance') }}</el-checkbox>
                <el-checkbox :label="2">{{ $t('navbar.ForcePhoto') }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addDialog = false">{{ $t('collectionCenter.cancel') }}
        </el-button>
        <el-button size="small" type="primary" @click="addDeregistrationSubmit">{{ $t('collectionCenter.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import {
  addProblemLimitRelease,
  deleteProblemLimitRelease,
  exportProblemLimitRelease,
  getProblemLimitReleasePage
} from '@/api/resources';
import { goResourceTaskList } from '@/utils/goExportList';

const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59';
export default {
  name: 'Deregistration',
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          releaseTime: [startTime, endTime],
          waybillNumber: '',
          unRestrictTypeList: []
        },
        total: 0
      },
      tableData: [],
      tableHeaderList: [
        {
          label: this.$t('navbar.jiechuTime'),
          prop: 'releaseTime',
          cloWidth: '180',
          cloAlign: 'center',
          isTips: false
        },
        {
          label: this.$t('navbar.jiechuWillybNumber'),
          prop: 'waybillNumber',
          cloWidth: '200',
          cloAlign: 'center',
          isTips: true
        },
        {
          label: this.$t('navbar.rescissionTypeName'),
          prop: 'unrestrictType',
          cloWidth: '200',
          cloAlign: 'center',
          isTips: true
        },
        {
          label: this.$t('collectionCenter.operator'),
          prop: 'operatorName',
          cloWidth: '150',
          cloAlign: 'center',
          isTips: true
        }
      ],
      addDialog: false,
      restrictionLiftedForm: {
        waybillNumbers: '',
        unRestrictTypeList: []
      },
      tableKey: new Date().getTime()
    };
  },
  created() {
    this.enterSearch();
  },
  methods: {
    // 删除
    deleteDeregistration(row) {
      this.$confirm(this.$t('GlobalSetObj.AreYouSureDelete'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'),
        cancelButtonText: this.$t('collectionCenter.cancel'),
        type: 'warning'
      }).then(() => {
        const data = {
          id: row.id
        };
        deleteProblemLimitRelease(data).then((res) => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.enterSearch();
          }
        });
      });
    },
    // 新增
    addDeregistration() {
      this.addDialog = true;
      this.$nextTick(() => {
        this.$refs.restrictionLiftedRef.resetFields();
        this.restrictionLiftedForm.unRestrictTypeList = [];
        this.restrictionLiftedForm.waybillNumbers = '';
      });
    },
    // 新增提交
    addDeregistrationSubmit() {
      this.$refs.restrictionLiftedRef.validate((valid) => {
        if (valid) {
          const data = {
            waybillNumberList: [],
            unRestrictTypeList: this.restrictionLiftedForm.unRestrictTypeList
          };
          // 过滤掉空元素
          data.waybillNumberList = this.restrictionLiftedForm.waybillNumbers
            .split(/[,，\n]+/) // 按逗号、中文逗号或换行符分割
            .map((item) => item.replace(/\s+/g, '')) // 清除每个元素中的所有空格
            .filter((item) => item !== '');
          addProblemLimitRelease(data).then((res) => {
            if (res.code === 200) {
              this.addDialog = false;
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.getSearch();
            }
          });
        }
      });
    },
    // 导出
    exportExcel() {
      exportProblemLimitRelease(this.getSearchData()).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 搜索
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.queryForm.params = {
        releaseTime: [startTime, endTime],
        waybillNumber: '',
        unRestrictTypeList: []
      };
      this.getSearch();
    },
    // 查询数据整理
    getSearchData() {
      const dataParams = {
        beginTime: null,
        endTime: null,
        unRestrictTypeList: this.queryForm.params.unRestrictTypeList,
        waybillNumberList: []
      };
      if (
        this.queryForm.params.waybillNumber === '' ||
        this.queryForm.params.waybillNumber === null ||
        this.queryForm.params.waybillNumber === undefined
      ) {
        dataParams.waybillNumberList = [];
      } else {
        dataParams.waybillNumberList = [this.queryForm.params.waybillNumber];
      }
      if (this.queryForm.params.releaseTime && this.queryForm.params.releaseTime.length > 0) {
        dataParams.beginTime = this.queryForm.params.releaseTime[0];
        dataParams.endTime = this.queryForm.params.releaseTime[1];
      }
      return dataParams;
    },
    // 查询列表数据
    getSearch() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.getSearchData()
      };
      getProblemLimitReleasePage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.tableKey = new Date().getTime();
        }
      });
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    }
  }
};
</script>
<style scoped></style>
